import { isFunction } from './typeguards/primatives';

/*
 * utilty function to call a function if it is defined
 * useful in stuations where a function may or may not be present
 */
export function callIfPresent(subject: unknown): void {
	if (isFunction(subject)) {
		subject();
	}
}
